import { useMemo, useState } from "react"
import { BreadCrumbItem } from "./types"

export const useTopBar = () => {
	const [breadCrumbs, setBreadCrumbs] = useState<BreadCrumbItem[]>([])
	return useMemo(() => ({
		breadCrumbs,
		setBreadCrumbs
	}), [
		breadCrumbs,
		setBreadCrumbs
	])	
}